import React, { useState } from 'react'
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import { logo } from "../../assets/index"
import { navLinksdata } from '../../constants';
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false)
  return (
    <div className="fixed top-0 left-0 right-0 z-50 font-titleFont flex justify-center py-3 px-4">
      <div className="max-w-7xl w-full h-14 mdl:h-16 xl:h-20 px-3 mdl:px-5 flex items-center justify-between gap-2 mdl:gap-6 border border-white/10 bg-white/5 backdrop-blur-xl rounded-full shadow-[0_10px_40px_rgba(0,0,0,0.45)]">
        <div className="flex items-center gap-3">
          <img src={logo} width={44} alt="logo" className="mdl:w-[56px] rounded-2xl shadow-md shadow-black/40" />
          <span className="hidden sm:inline-block text-[10px] mdl:text-sm tracking-[0.12em] mdl:tracking-[0.22em] uppercase text-gray-300">
            Aditya <span className="text-designColor">Portfolio</span>
          </span>
        </div>

        <div className="flex items-center gap-4">
          <ul className="hidden mdl:flex items-center gap-2 bg-white/5 backdrop-blur-2xl px-3 py-2 rounded-full border border-white/10 shadow-[0_8px_24px_rgba(0,0,0,0.35)]">
            {navLinksdata.map(({ _id, title, link }) => (
              <li
                key={_id}
                className="text-xs lg:text-sm font-medium text-gray-200 tracking-wide cursor-pointer px-3 py-1.5 rounded-full hover:text-white hover:bg-white/15 transition-colors duration-300"
              >
                <Link
                  activeClass="text-designColor"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>

          <div className="hidden mdl:flex items-center gap-3">
            <button
              className="hidden lg:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-designColor to-pink-500 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(0,0,0,0.55)] hover:shadow-[0_18px_45px_rgba(0,0,0,0.7)] hover:-translate-y-0.5 transition-all duration-300"
            >
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                Let&apos;s talk
              </Link>
            </button>
          </div>

          <span
            onClick={() => setShowMenu(!showMenu)}
            className="text-xl mdl:hidden bg-black/60 border border-white/10 w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer shadow-[0_8px_24px_rgba(0,0,0,0.55)] backdrop-blur-xl"
          >
            <FiMenu />
          </span>
        </div>
      </div>

      <AnimatePresence>
        {showMenu && (
          <>
            {/* Backdrop Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowMenu(false)}
              className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm mdl:hidden"
            />

            {/* Drawer Container */}
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="fixed top-0 left-0 z-50 w-[85%] max-w-[320px] h-screen bg-white/[0.03] backdrop-blur-3xl border-r border-white/10 p-6 shadow-[20px_0_80px_rgba(0,0,0,0.4)] flex flex-col scrollbar-hide mdl:hidden"
            >
              <div className="flex flex-col gap-10 py-2 relative h-full">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <img width={"48px"} src={logo} alt="logo" className="rounded-xl shadow-md shadow-black/40" />
                    <span className="text-xs font-bold tracking-widest uppercase text-gray-300">
                      Aditya <span className="text-designColor">Portfolio</span>
                    </span>
                  </div>
                  <motion.span
                    whileTap={{ scale: 0.9 }}
                    onClick={() => setShowMenu(false)}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-gray-400 hover:text-designColor transition-colors cursor-pointer"
                  >
                    <MdClose size={24} />
                  </motion.span>
                </div>

                <ul className="flex flex-col gap-6 mt-4">
                  {navLinksdata.map((item, idx) => (
                    <motion.li
                      key={item._id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.1 + idx * 0.05 }}
                      className="text-lg font-medium text-gray-300 tracking-wide cursor-pointer hover:text-designColor transition-colors"
                    >
                      <Link
                        onClick={() => setShowMenu(false)}
                        activeClass="text-designColor"
                        to={item.link}
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="flex items-center gap-4 w-full"
                      >
                        {item.title}
                      </Link>
                    </motion.li>
                  ))}
                </ul>

                <div className="mt-auto pb-10">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="flex flex-col gap-6"
                  >
                    <div>
                      <h2 className="text-xs uppercase font-medium mb-4 tracking-[0.2em] text-gray-500">
                        Find me in
                      </h2>
                      <div className="flex gap-4">
                        {[
                          { icon: <FaWhatsapp size={22} />, link: "https://wa.me/+917000385306" },
                          { icon: <IoIosMail size={22} />, link: `https://mail.google.com/mail/?view=cm&fs=1&to=imdev.aditya@gmail.com` },
                          { icon: <FaLinkedinIn size={22} />, link: "https://www.linkedin.com/in/imdev-aditya" }
                        ].map((social, idx) => (
                          <motion.span
                            key={idx}
                            whileHover={{ y: -3, scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-gray-300 hover:text-designColor hover:border-designColor/30 transition-all cursor-pointer shadow-lg"
                            onClick={() => window.open(social.link, "_blank", "noopener,noreferrer")}
                          >
                            {social.icon}
                          </motion.span>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Navbar